export default "__VITE_ASSET__DHndONKA__"